<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    id="abnormal-dialog"
    :show-close="false"
    >
    <span>需登录后查看私密商品</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleBack">返回供销商小店</el-button>
      <el-button @click="handleLogin" type="primary">立即登录</el-button>
    </span>
    </el-dialog>
</template>

<script>

export default {
  data() {
    return{
      dialogVisible: false
    }
  },
  methods: {
    handleBack() {
      this.dialogVisible = false;
      this.$router.replace({
        name: 'un_distributeShop',
        query: {
          supplierId: this.$route.query.supplierId
        }
      })
    },
    handleLogin() {
      this.$emit('login');
    },
    method_open() {
      this.dialogVisible = true
    },
  }

}
</script>

<style lang="scss" scoped>
  // .all-blur {
  //   backdrop-filter: blur(2px);
  // }
   ::v-deep .el-dialog__body {
    min-height: 0;
  }
  
</style>

<style>
#abnormal-dialog  {
  backdrop-filter: blur(2px);
}
</style>
